import { createSelector } from "reselect";
import { AppState } from "../types";

/** Selects the notebook state. Don't export this root state. */
const getTimer = (state: AppState) => state.timer;

/** Selects the session timeout on the timer. */
export const getSessionTimeoutSeconds = createSelector(
  [getTimer],
  timer => timer.sessionTimeoutSeconds
);

/** Selects the inital epoch time. */
export const getInitialEpochTime = createSelector(
  [getTimer],
  timer => timer.initialEpochTime
);
